export default [
	{
		"hex": "#d86c6a"
	},
	{
		"hex": "#d17359"
	},
	{
		"hex": "#f7ec59"
	},
	{
		"hex": "#7292ea"
	},
	{
		"hex": "#c4f8ff"
	},
	{
		"hex": "#ac85e2"
	},
	{
		"hex": "#957bfc"
	},
	{
		"hex": "#bfffa5"
	},
	{
		"hex": "#ced330"
	},
	{
		"hex": "#547003"
	},
	{
		"hex": "#66f9e6"
	},
	{
		"hex": "#aedd71"
	},
	{
		"hex": "#f9a2df"
	},
	{
		"hex": "#fce1bf"
	},
	{
		"hex": "#b2db43"
	},
	{
		"hex": "#1ecc78"
	},
	{
		"hex": "#fcf78f"
	},
	{
		"hex": "#4432e5"
	},
	{
		"hex": "#9180e5"
	},
	{
		"hex": "#eae272"
	},
	{
		"hex": "#ba7301"
	},
	{
		"hex": "#eca9f9"
	},
	{
		"hex": "#f9d657"
	},
	{
		"hex": "#ba85db"
	},
	{
		"hex": "#98c2e0"
	},
	{
		"hex": "#5dd356"
	},
	{
		"hex": "#fcbfcc"
	},
	{
		"hex": "#58c7c9"
	},
	{
		"hex": "#6eef85"
	},
	{
		"hex": "#55990d"
	},
	{
		"hex": "#fc88d3"
	},
	{
		"hex": "#d0c9ff"
	},
	{
		"hex": "#bf6d3b"
	},
	{
		"hex": "#efef8b"
	},
	{
		"hex": "#1e47a8"
	},
	{
		"hex": "#4bad0d"
	},
	{
		"hex": "#7c2ba5"
	},
	{
		"hex": "#218da0"
	},
	{
		"hex": "#81e552"
	},
	{
		"hex": "#d098e2"
	},
	{
		"hex": "#ecf9a7"
	},
	{
		"hex": "#f0f4a1"
	},
	{
		"hex": "#dd0675"
	},
	{
		"hex": "#e660f2"
	},
	{
		"hex": "#15c48f"
	},
	{
		"hex": "#ccf970"
	},
	{
		"hex": "#4efcc8"
	},
	{
		"hex": "#87b2f2"
	},
	{
		"hex": "#46d10a"
	},
	{
		"hex": "#e585ca"
	},
	{
		"hex": "#e2ef7c"
	},
	{
		"hex": "#85eab6"
	},
	{
		"hex": "#e830cc"
	},
	{
		"hex": "#e8889d"
	},
	{
		"hex": "#87b5f2"
	},
	{
		"hex": "#cac7fc"
	},
	{
		"hex": "#a6e861"
	},
	{
		"hex": "#760bef"
	},
	{
		"hex": "#1efc3f"
	},
	{
		"hex": "#5bffaa"
	},
	{
		"hex": "#96f2a7"
	},
	{
		"hex": "#f2a991"
	},
	{
		"hex": "#a5f7ad"
	},
	{
		"hex": "#89e5b3"
	},
	{
		"hex": "#7a6ac9"
	},
	{
		"hex": "#efaedd"
	},
	{
		"hex": "#f7bee7"
	},
	{
		"hex": "#2a7f03"
	},
	{
		"hex": "#c7c5f9"
	},
	{
		"hex": "#394a96"
	},
	{
		"hex": "#edd51e"
	},
	{
		"hex": "#0003bc"
	},
	{
		"hex": "#e28ed9"
	},
	{
		"hex": "#276284"
	},
	{
		"hex": "#e25f80"
	},
	{
		"hex": "#b8d660"
	},
	{
		"hex": "#eeff3d"
	},
	{
		"hex": "#ce0cce"
	},
	{
		"hex": "#f5fca9"
	},
	{
		"hex": "#66a9d6"
	},
	{
		"hex": "#cdffb2"
	},
	{
		"hex": "#07753c"
	},
	{
		"hex": "#ef4cea"
	},
	{
		"hex": "#098e20"
	},
	{
		"hex": "#f9b8cb"
	},
	{
		"hex": "#9ef7d5"
	},
	{
		"hex": "#b4c43a"
	},
	{
		"hex": "#cef7a0"
	},
	{
		"hex": "#efba8b"
	},
	{
		"hex": "#6ce2a7"
	},
	{
		"hex": "#23559b"
	},
	{
		"hex": "#b4bc3a"
	},
	{
		"hex": "#96e212"
	},
	{
		"hex": "#34ef8b"
	},
	{
		"hex": "#dd1ac0"
	},
	{
		"hex": "#f7a5c3"
	},
	{
		"hex": "#75ddda"
	},
	{
		"hex": "#7de8af"
	},
	{
		"hex": "#b2720a"
	},
	{
		"hex": "#7f37b2"
	},
	{
		"hex": "#1ec41b"
	},
	{
		"hex": "#c49405"
	},
	{
		"hex": "#9df2d5"
	},
	{
		"hex": "#042791"
	},
	{
		"hex": "#68fc58"
	},
	{
		"hex": "#47ed7e"
	},
	{
		"hex": "#89f407"
	},
	{
		"hex": "#bf11ad"
	},
	{
		"hex": "#78f45d"
	},
	{
		"hex": "#a7f78a"
	},
	{
		"hex": "#575ebf"
	},
	{
		"hex": "#027a6e"
	},
	{
		"hex": "#8bf276"
	},
	{
		"hex": "#ea3578"
	},
	{
		"hex": "#948edb"
	},
	{
		"hex": "#f484c9"
	},
	{
		"hex": "#daf90e"
	},
	{
		"hex": "#cffc19"
	},
	{
		"hex": "#c4bcf4"
	},
	{
		"hex": "#97a1e5"
	},
	{
		"hex": "#69b8e5"
	},
	{
		"hex": "#babef2"
	},
	{
		"hex": "#99bef7"
	},
	{
		"hex": "#923dcc"
	},
	{
		"hex": "#ab4adb"
	},
	{
		"hex": "#fce9a9"
	},
	{
		"hex": "#0300ef"
	},
	{
		"hex": "#79c2d1"
	},
	{
		"hex": "#f2a7ae"
	},
	{
		"hex": "#017f6c"
	},
	{
		"hex": "#eac48f"
	},
	{
		"hex": "#8956ff"
	},
	{
		"hex": "#a9fcbd"
	},
	{
		"hex": "#9a6dce"
	},
	{
		"hex": "#e89bd4"
	},
	{
		"hex": "#a2b3f2"
	},
	{
		"hex": "#93ed93"
	},
	{
		"hex": "#3ba001"
	},
	{
		"hex": "#e8cf96"
	},
	{
		"hex": "#af3aea"
	},
	{
		"hex": "#1de588"
	},
	{
		"hex": "#97f4e3"
	},
	{
		"hex": "#3002e8"
	},
	{
		"hex": "#8d89f9"
	},
	{
		"hex": "#6ddb74"
	},
	{
		"hex": "#e8580b"
	},
	{
		"hex": "#d8009e"
	},
	{
		"hex": "#a7f9d0"
	},
	{
		"hex": "#e199e5"
	},
	{
		"hex": "#69e0ac"
	},
	{
		"hex": "#18bc51"
	},
	{
		"hex": "#b73150"
	},
	{
		"hex": "#e2ed50"
	},
	{
		"hex": "#3d3bdb"
	},
	{
		"hex": "#2161af"
	},
	{
		"hex": "#ffd7cc"
	},
	{
		"hex": "#b249d8"
	},
	{
		"hex": "#dd7aba"
	},
	{
		"hex": "#18afbc"
	},
	{
		"hex": "#07ed76"
	},
	{
		"hex": "#f975cb"
	},
	{
		"hex": "#e87c43"
	},
	{
		"hex": "#a09df2"
	},
	{
		"hex": "#9ebc2f"
	},
	{
		"hex": "#ffadbf"
	},
	{
		"hex": "#bf003f"
	},
	{
		"hex": "#9164c4"
	},
	{
		"hex": "#cc2839"
	},
	{
		"hex": "#ea9067"
	},
	{
		"hex": "#f77b42"
	},
	{
		"hex": "#016aaa"
	},
	{
		"hex": "#5ac9c9"
	},
	{
		"hex": "#ccfcff"
	},
	{
		"hex": "#d9ef6b"
	},
	{
		"hex": "#ddb3ef"
	},
	{
		"hex": "#c4e560"
	},
	{
		"hex": "#f26371"
	},
	{
		"hex": "#fce7c2"
	},
	{
		"hex": "#09c49f"
	},
	{
		"hex": "#d1c710"
	},
	{
		"hex": "#03842e"
	},
	{
		"hex": "#0a3e7f"
	},
	{
		"hex": "#50c4ce"
	},
	{
		"hex": "#186a7c"
	},
	{
		"hex": "#16ceb2"
	},
	{
		"hex": "#fff3bc"
	},
	{
		"hex": "#fc37b0"
	},
	{
		"hex": "#e8b48b"
	},
	{
		"hex": "#f9f7a7"
	},
	{
		"hex": "#0f6aaa"
	},
	{
		"hex": "#fc3f2a"
	},
	{
		"hex": "#efa2d4"
	},
	{
		"hex": "#2fbce0"
	},
	{
		"hex": "#3ec476"
	},
	{
		"hex": "#4f5ac1"
	},
	{
		"hex": "#d3b419"
	},
	{
		"hex": "#3640af"
	},
	{
		"hex": "#7ba6ed"
	},
	{
		"hex": "#e50295"
	},
	{
		"hex": "#9ee57e"
	},
	{
		"hex": "#e26c7a"
	},
	{
		"hex": "#4bf470"
	},
	{
		"hex": "#ecaeef"
	},
	{
		"hex": "#b2ffdc"
	},
	{
		"hex": "#82edd6"
	},
	{
		"hex": "#86ed71"
	},
	{
		"hex": "#4ee57d"
	},
	{
		"hex": "#4ff7f9"
	},
	{
		"hex": "#3af4cf"
	},
	{
		"hex": "#63f278"
	},
	{
		"hex": "#eeabf2"
	},
	{
		"hex": "#d35d61"
	},
	{
		"hex": "#e1ef62"
	},
	{
		"hex": "#eae019"
	},
	{
		"hex": "#e8d64e"
	},
	{
		"hex": "#e51b68"
	},
	{
		"hex": "#b28f1e"
	},
	{
		"hex": "#f481e3"
	},
	{
		"hex": "#c7baff"
	},
	{
		"hex": "#f263c9"
	},
	{
		"hex": "#d64d9f"
	},
	{
		"hex": "#bad147"
	},
	{
		"hex": "#0d3370"
	},
	{
		"hex": "#c4eefc"
	},
	{
		"hex": "#81e014"
	},
	{
		"hex": "#d8503e"
	},
	{
		"hex": "#15d4db"
	},
	{
		"hex": "#c23fe2"
	},
	{
		"hex": "#79fcce"
	},
	{
		"hex": "#67f792"
	},
	{
		"hex": "#db3951"
	},
	{
		"hex": "#66e060"
	},
	{
		"hex": "#8cea60"
	},
	{
		"hex": "#f9f7b1"
	},
	{
		"hex": "#5df784"
	},
	{
		"hex": "#61e861"
	},
	{
		"hex": "#8b26c1"
	},
	{
		"hex": "#d3ca21"
	},
	{
		"hex": "#02f7c2"
	},
	{
		"hex": "#d809ef"
	},
	{
		"hex": "#ffe6c4"
	},
	{
		"hex": "#470570"
	},
	{
		"hex": "#ed5ede"
	},
	{
		"hex": "#e5d264"
	},
	{
		"hex": "#65d8bd"
	},
	{
		"hex": "#ce9aed"
	},
	{
		"hex": "#db5246"
	},
	{
		"hex": "#0177b7"
	},
	{
		"hex": "#c153e0"
	},
	{
		"hex": "#80fcc4"
	},
	{
		"hex": "#80e5af"
	},
	{
		"hex": "#e0e041"
	},
	{
		"hex": "#1bf1fc"
	},
	{
		"hex": "#d34b39"
	},
	{
		"hex": "#e246c3"
	},
	{
		"hex": "#d8f79b"
	},
	{
		"hex": "#6c9618"
	},
	{
		"hex": "#ed1efc"
	},
	{
		"hex": "#4380a0"
	},
	{
		"hex": "#edd0a3"
	},
	{
		"hex": "#e87d89"
	},
	{
		"hex": "#3067f2"
	},
	{
		"hex": "#efa2e9"
	},
	{
		"hex": "#e4fc85"
	},
	{
		"hex": "#48bff2"
	},
	{
		"hex": "#8dafef"
	},
	{
		"hex": "#76c5d3"
	},
	{
		"hex": "#7be5e3"
	},
	{
		"hex": "#e204d4"
	},
	{
		"hex": "#ef7b51"
	},
	{
		"hex": "#fcad85"
	},
	{
		"hex": "#f9c2ce"
	},
	{
		"hex": "#8bd4d6"
	},
	{
		"hex": "#19a309"
	},
	{
		"hex": "#b70e4c"
	},
	{
		"hex": "#b28fe0"
	},
	{
		"hex": "#fcf599"
	},
	{
		"hex": "#fcc7db"
	},
	{
		"hex": "#393593"
	},
	{
		"hex": "#5041ad"
	},
	{
		"hex": "#8be8e6"
	},
	{
		"hex": "#237503"
	},
	{
		"hex": "#bf3b51"
	},
	{
		"hex": "#a5e256"
	},
	{
		"hex": "#c2a6ea"
	},
	{
		"hex": "#cc8849"
	},
	{
		"hex": "#084775"
	},
	{
		"hex": "#ef8fb7"
	},
	{
		"hex": "#efc864"
	},
	{
		"hex": "#1a00e5"
	},
	{
		"hex": "#c0f0f7"
	},
	{
		"hex": "#37a4ba"
	},
	{
		"hex": "#7bb8ed"
	},
	{
		"hex": "#a2f9cf"
	},
	{
		"hex": "#09e293"
	},
	{
		"hex": "#f756a6"
	},
	{
		"hex": "#0c8c2a"
	},
	{
		"hex": "#f7b64f"
	},
	{
		"hex": "#94bf39"
	},
	{
		"hex": "#9d2aea"
	},
	{
		"hex": "#91eab0"
	},
	{
		"hex": "#f7f9ac"
	},
	{
		"hex": "#1de506"
	},
	{
		"hex": "#6fe29b"
	},
	{
		"hex": "#85af05"
	},
	{
		"hex": "#aefcde"
	},
	{
		"hex": "#ef56b7"
	},
	{
		"hex": "#8abfe2"
	},
	{
		"hex": "#cafc67"
	},
	{
		"hex": "#d6ab40"
	},
	{
		"hex": "#93e559"
	},
	{
		"hex": "#81f4d8"
	},
	{
		"hex": "#abf99f"
	},
	{
		"hex": "#d6af2f"
	},
	{
		"hex": "#50d85b"
	},
	{
		"hex": "#63f952"
	},
	{
		"hex": "#ad81e2"
	},
	{
		"hex": "#a5ffde"
	},
	{
		"hex": "#eae01c"
	},
	{
		"hex": "#e96ff7"
	},
	{
		"hex": "#adffd8"
	},
	{
		"hex": "#b163dd"
	},
	{
		"hex": "#cc04c5"
	},
	{
		"hex": "#53e2b0"
	},
	{
		"hex": "#f2c0f9"
	},
	{
		"hex": "#efacb5"
	},
	{
		"hex": "#97ebfc"
	},
	{
		"hex": "#1ab284"
	},
	{
		"hex": "#3a65c1"
	},
	{
		"hex": "#f99a6d"
	},
	{
		"hex": "#c94a6c"
	},
	{
		"hex": "#5947e0"
	},
	{
		"hex": "#67c42d"
	},
	{
		"hex": "#4c8eb2"
	},
	{
		"hex": "#2dbca4"
	},
	{
		"hex": "#02267a"
	},
	{
		"hex": "#f75164"
	},
	{
		"hex": "#34949b"
	},
	{
		"hex": "#72e0ca"
	},
	{
		"hex": "#e85a74"
	},
	{
		"hex": "#ef51e5"
	},
	{
		"hex": "#fc5364"
	},
	{
		"hex": "#0a7a04"
	},
	{
		"hex": "#ef8964"
	},
	{
		"hex": "#4400b2"
	},
	{
		"hex": "#80b526"
	},
	{
		"hex": "#6ac13c"
	},
	{
		"hex": "#5c0d84"
	},
	{
		"hex": "#910215"
	},
	{
		"hex": "#f2e793"
	},
	{
		"hex": "#efb332"
	},
	{
		"hex": "#536fed"
	},
	{
		"hex": "#a6a1ea"
	},
	{
		"hex": "#73dd98"
	},
	{
		"hex": "#abfcb6"
	},
	{
		"hex": "#bf9003"
	},
	{
		"hex": "#bdfcab"
	},
	{
		"hex": "#04dd3e"
	},
	{
		"hex": "#ef8f9f"
	},
	{
		"hex": "#f45de5"
	},
	{
		"hex": "#e74dea"
	},
	{
		"hex": "#b9fcab"
	},
	{
		"hex": "#84db39"
	},
	{
		"hex": "#ed8474"
	},
	{
		"hex": "#f43089"
	},
	{
		"hex": "#f9e234"
	},
	{
		"hex": "#6bdfe5"
	},
	{
		"hex": "#ffa977"
	},
	{
		"hex": "#efef34"
	},
	{
		"hex": "#23a894"
	},
	{
		"hex": "#a6fcf5"
	},
	{
		"hex": "#47ce40"
	},
	{
		"hex": "#86f9d1"
	},
	{
		"hex": "#6433c6"
	},
	{
		"hex": "#055291"
	},
	{
		"hex": "#d10c7f"
	},
	{
		"hex": "#e1f9a9"
	},
	{
		"hex": "#fca9c0"
	},
	{
		"hex": "#f9d354"
	},
	{
		"hex": "#e238e0"
	},
	{
		"hex": "#db53a7"
	},
	{
		"hex": "#353491"
	},
	{
		"hex": "#7ae2be"
	},
	{
		"hex": "#db6fc4"
	},
	{
		"hex": "#f7afe6"
	},
	{
		"hex": "#68d680"
	},
	{
		"hex": "#fcc4f5"
	},
	{
		"hex": "#29b252"
	},
	{
		"hex": "#e5c962"
	},
	{
		"hex": "#27f7e6"
	},
	{
		"hex": "#239112"
	},
	{
		"hex": "#ed64ef"
	},
	{
		"hex": "#ed2de9"
	},
	{
		"hex": "#a2e076"
	},
	{
		"hex": "#59e07f"
	},
	{
		"hex": "#f79567"
	},
	{
		"hex": "#c44c54"
	},
	{
		"hex": "#91120e"
	},
	{
		"hex": "#99d5fc"
	},
	{
		"hex": "#d6cc48"
	},
	{
		"hex": "#eab7ff"
	},
	{
		"hex": "#fcd5a1"
	},
	{
		"hex": "#03a562"
	},
	{
		"hex": "#cf99e8"
	},
	{
		"hex": "#f9aec4"
	},
	{
		"hex": "#129b92"
	},
	{
		"hex": "#88d0f7"
	},
	{
		"hex": "#a5f9a2"
	},
	{
		"hex": "#2057a0"
	},
	{
		"hex": "#d1472b"
	},
	{
		"hex": "#bf3c1e"
	},
	{
		"hex": "#84b4e8"
	},
	{
		"hex": "#9d47ff"
	},
	{
		"hex": "#e0c686"
	},
	{
		"hex": "#e082ac"
	},
	{
		"hex": "#9a6bdb"
	},
	{
		"hex": "#ed9f95"
	},
	{
		"hex": "#a035f2"
	},
	{
		"hex": "#d350d3"
	},
	{
		"hex": "#3c299b"
	},
	{
		"hex": "#21d80d"
	},
	{
		"hex": "#35c6f2"
	},
	{
		"hex": "#3cfc9c"
	},
	{
		"hex": "#ead196"
	},
	{
		"hex": "#9b37e8"
	},
	{
		"hex": "#087a52"
	},
	{
		"hex": "#4ff982"
	},
	{
		"hex": "#662eba"
	},
	{
		"hex": "#2db52b"
	},
	{
		"hex": "#636af2"
	},
	{
		"hex": "#7de506"
	},
	{
		"hex": "#2804db"
	},
	{
		"hex": "#afffca"
	},
	{
		"hex": "#baffaa"
	},
	{
		"hex": "#2892a3"
	},
	{
		"hex": "#eda81e"
	},
	{
		"hex": "#fcc99c"
	},
	{
		"hex": "#c2e577"
	},
	{
		"hex": "#1ad8c2"
	},
	{
		"hex": "#ee9eff"
	},
	{
		"hex": "#a7f9c5"
	},
	{
		"hex": "#f438e5"
	},
	{
		"hex": "#ef37af"
	},
	{
		"hex": "#c52ce0"
	},
	{
		"hex": "#38e0ad"
	},
	{
		"hex": "#fcceb3"
	},
	{
		"hex": "#fcebc2"
	},
	{
		"hex": "#30b542"
	},
	{
		"hex": "#9e1235"
	},
	{
		"hex": "#157599"
	},
	{
		"hex": "#684cb5"
	},
	{
		"hex": "#f3bafc"
	},
	{
		"hex": "#c292f4"
	},
	{
		"hex": "#d2e580"
	},
	{
		"hex": "#28bf6c"
	},
	{
		"hex": "#ffc6f0"
	},
	{
		"hex": "#ba6b0b"
	},
	{
		"hex": "#8e9900"
	},
	{
		"hex": "#d569db"
	},
	{
		"hex": "#4d3ac9"
	},
	{
		"hex": "#09228e"
	},
	{
		"hex": "#f2a9e1"
	},
	{
		"hex": "#ff9eb7"
	},
	{
		"hex": "#6ef257"
	},
	{
		"hex": "#a4b2f4"
	},
	{
		"hex": "#fce1b5"
	},
	{
		"hex": "#6ebaf4"
	},
	{
		"hex": "#cc74ed"
	},
	{
		"hex": "#2faf0f"
	},
	{
		"hex": "#e29083"
	},
	{
		"hex": "#52f42e"
	},
	{
		"hex": "#1bb537"
	},
	{
		"hex": "#5fe2d7"
	},
	{
		"hex": "#055177"
	},
	{
		"hex": "#c48fe8"
	},
	{
		"hex": "#f2b09b"
	},
	{
		"hex": "#ff4f19"
	},
	{
		"hex": "#902ec9"
	},
	{
		"hex": "#4ae0a4"
	},
	{
		"hex": "#dd89c5"
	},
	{
		"hex": "#480f99"
	},
	{
		"hex": "#3d5dff"
	},
	{
		"hex": "#f7aab4"
	},
	{
		"hex": "#f7cb2c"
	},
	{
		"hex": "#259b04"
	},
	{
		"hex": "#ea07b1"
	},
	{
		"hex": "#264499"
	},
	{
		"hex": "#d33245"
	},
	{
		"hex": "#c6c003"
	},
	{
		"hex": "#73d664"
	},
	{
		"hex": "#8089ce"
	},
	{
		"hex": "#9e95e5"
	},
	{
		"hex": "#f484af"
	},
	{
		"hex": "#bc05ff"
	},
	{
		"hex": "#aa3bd6"
	},
	{
		"hex": "#b3eff2"
	},
	{
		"hex": "#04ea10"
	},
	{
		"hex": "#fff8bc"
	},
	{
		"hex": "#ea935d"
	},
	{
		"hex": "#cea0e8"
	}
];



// WEBPACK FOOTER //
// ./src/colors.js